import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconUsbModemProps } from './IconUsbModem.types'
import * as Styled from './styles/IconUsbModem.style'

import { nonThemeableRules } from '../../ruleSet'

const IconUsbModem: FC<IconUsbModemProps> = ({
  size = nonThemeableRules.defaultSize as number as IconUsbModemProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconUsbModemProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 192 192' xmlns='http://www.w3.org/2000/svg'>
        <rect height='64.15' width='107.02' fill='none' rx='11' vectorEffect='non-scaling-stroke' x='23.96' y='107.86' />
        <path d='M130.98 116.92h37.06v46.02h-37.06zM20.17 43.93a81 81 0 0 1 114.54 0' fill='none' vectorEffect='non-scaling-stroke' />
        <path
          d='M36.76 61.28a57.86 57.86 0 0 1 81.83 0M53.8 78.29a33.62 33.62 0 0 1 47.55 0M144 148.72h8m-8-17.57h8'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconUsbModem
